export * from './localizacao-slice'